const isAbsoluteHttpUrl = (value) => /^https?:\/\//i.test(value || "");

const ensureTrailingSlash = (value) =>
  value.endsWith("/") ? value : `${value}/`;

export const getSiteConnectorAdminPath = (siteConnector) => {
  if (!siteConnector || typeof siteConnector !== "object") {
    return null;
  }

  return (
    siteConnector.site_admin_path ||
    siteConnector.wp_site_admin_url_path ||
    null
  );
};

const buildAdminBaseUrl = (origin, siteConnector) => {
  const adminPath = getSiteConnectorAdminPath(siteConnector);

  if (!adminPath) {
    return `${origin}/wp-admin/`;
  }

  if (isAbsoluteHttpUrl(adminPath)) {
    const adminUrl = new URL(adminPath);
    adminUrl.search = "";
    adminUrl.hash = "";
    adminUrl.pathname = ensureTrailingSlash(adminUrl.pathname);
    return adminUrl.toString();
  }

  const normalizedPath = ensureTrailingSlash(
    adminPath.startsWith("/") ? adminPath : `/${adminPath}`
  );

  return `${origin}${normalizedPath}`;
};

export const buildPostAdminUrl = ({ postUrl, postId, siteConnector }) => {
  if (!postUrl || !postId) {
    return null;
  }

  let parsedUrl;
  try {
    parsedUrl = new URL(postUrl);
  } catch (error) {
    return null;
  }

  if (parsedUrl.origin.includes("marmiton")) {
    return `${parsedUrl.origin}/reloaded/manage/story/list#/13/list/edit/${postId}`;
  }

  if (parsedUrl.origin.includes("lesnum")) {
    return `https://redaction2.lesnums.com/publication/news/${postId}/edit`;
  }

  const adminBaseUrl = buildAdminBaseUrl(parsedUrl.origin, siteConnector);
  const editUrl = new URL("post.php", adminBaseUrl);
  editUrl.searchParams.set("post", postId);
  editUrl.searchParams.set("action", "edit");

  return editUrl.toString();
};
